import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Paper, Box, Select, MenuItem, FormControl, Checkbox, ListItemText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setFilter } from '../../store/reducers/stateReducer';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import { setDataLayer } from '../../store/reducers/helpersReducer';

const stagesColors = {
    "1": '220,20,60',   // Темно-красный (Препроектное обследование - начало)
    "2": '255,140,0',   // Темно-оранжевый (Рабочая документация - в процессе)
    "3": '0,150,255',   // Глубокий небесно-голубой (Геодезическая разбивка - почти готово)
    "4": '100,230,0'    // Яркий зеленый лайм (Исполнительная съемка - завершено)
}

const StageSelectControl = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const containerRef = useRef(null);

    const stages = [
        { value: 1, label: 'Предпроектное обследование' },
        { value: 2, label: 'Рабочая документация' },
        { value: 3, label: 'Геодезическая разбивка' },
        { value: 4, label: 'Исполнительная съёмка' }
    ];
    const allStageValues = stages.map(s => s.value);

    const currentStageFilter = useSelector(state => state.state.filter.stage);

    const getInitialStages = () => {
        if (Array.isArray(currentStageFilter) && currentStageFilter.length > 0) {
            return currentStageFilter;
        }
        if (!currentStageFilter) { // Includes 0, null, undefined
            return allStageValues;
        }
        if (typeof currentStageFilter === 'number' && currentStageFilter > 0) {
            return [currentStageFilter];
        }
        return [];
    };

    const [stagesSelected, setStagesSelected] = useState(getInitialStages);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => dispatch(setFilter({ stage: stagesSelected })), 10);
        setTimeout(() => dispatch(setDataLayer({ name: 'viewStagesBackLight', state: stagesSelected.length > 1 })), 10);


    };

    useEffect(() => {
        setTimeout(() => dispatch(setDataLayer({ name: 'viewStagesBackLight', state: getInitialStages().length > 1 })), 10);
    }, [])

    const handleOpen = () => {
        setOpen(true);
    };

    // const handleSelectAll = (event) => {
    //     event.stopPropagation();
    //     if (stagesSelected.length === allStageValues.length) {
    //         setStagesSelected([]);
    //     } else {
    //         setStagesSelected(allStageValues);
    //     }
    // };

    const handleStageChange = (event) => {
        const { target: { value } } = event;
        console.log(value)
        if (value.includes(0)) {
            if (stagesSelected.length === allStageValues.length) {
                setStagesSelected([]);
            } else {
                setStagesSelected(allStageValues);
            }
        } else {
            setStagesSelected(
                typeof value === 'string' ? value.split(',') : value,
            );
        }


    };

    useEffect(() => {
        if (containerRef.current) {
            L.DomEvent.disableScrollPropagation(containerRef.current);
            // Не отключаем clickPropagation, чтобы селект мог работать
        }
    }, []);

    const renderValue = (selected) => {
        console.log(selected, selected.length)
        if (selected.length === allStageValues.length) {
            return "Все этапы";
        }
        if (selected.length === 0) {
            console.log("Этапы не выбраны")
            return "Этапы не выбраны";
        }
        if (selected.length === 1) {
            const stage = stages.find(s => s.value === selected[0]);
            return stage ? stage.label : `Выбрано: ${selected.length}`;
        }
        return `Выбрано: ${selected.length}`;
    };

    return createPortal(
        <Box
            ref={containerRef}
            sx={{
                zIndex: 1202,
                display: 'flex',
                order: 3,
                pointerEvents: 'auto',
                width: 'fit-content'
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: window.innerWidth < 768 ? 75 : 100,
                    height: window.innerWidth < 768 ? 26 : 34,
                    opacity: 0.9,
                    bgcolor: 'rgb(40, 40, 40)',
                    boxShadow: '0px 2px 6px grey',
                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover': {
                        bgcolor: 'rgb(50, 50, 50)',
                        transform: 'scale(1.02)',
                    },
                }}
            >
                <FormControl fullWidth>
                    <Select
                        multiple
                        displayEmpty
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        value={stagesSelected}
                        onChange={handleStageChange}
                        renderValue={renderValue}
                        variant="standard"
                        disableUnderline
                        sx={{
                            color: stagesSelected.length !== allStageValues.length ? 'orange' : 'white',
                            '& .MuiSelect-icon': {
                                color: stagesSelected.length !== allStageValues.length ? 'orange' : 'white',
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 12px',
                                fontSize: { xs: '11px', md: '14px' },
                                fontWeight: 500,
                            },
                            '& .MuiTypography-root': {
                                fontSize: { xs: '11px', md: '14px' },
                            }
                        }}
                        MenuProps={{
                            disablePortal: false,
                            PaperProps: {
                                sx: {
                                    bgcolor: 'rgb(40, 40, 40)',
                                    border: '1px solid rgb(60, 60, 60)',
                                    zIndex: 1300,
                                    '& .MuiList-root': {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        fontSize: { xs: '11px', md: '14px' },
                                        gap: 0,
                                        p: 0
                                    },
                                    '& .MuiMenuItem-root': {
                                        minHeight: '10px',
                                        padding: '2px 16px 2px 0',
                                        color: 'white',
                                        fontSize: { xs: '11px', md: '14px' },
                                        '&:hover': {
                                            bgcolor: 'rgb(60, 60, 60)',
                                        },
                                        '&.Mui-selected': {
                                            bgcolor: 'rgba(0, 174, 255, 0.3)',
                                            '&:hover': {
                                                bgcolor: 'rgba(0, 174, 255, 0.4)',
                                            },
                                        },
                                        '& .MuiTypography-root': {
                                            fontSize: { xs: '11px', md: '14px' },
                                        }
                                    },
                                    '& .MuiCheckbox-root': {
                                        p: 0.5
                                    },
                                    '& .MuiTypography-root': {
                                        fontSize: { xs: '11px', md: '14px' },
                                    }
                                },
                            },
                        }}
                    >
                        <MenuItem key={0} value={0}>
                            <ListItemText sx={{ padding: '6px 16px 6px 12px' }} primary="Все этапы" />
                        </MenuItem>
                        {stages.map((s) => (
                            <MenuItem 
                                key={s.value} 
                                value={s.value}
                                sx={{
                                    bgcolor: `rgba(${stagesColors[s.value]}, 0.3)`,
                                    '&:hover': {
                                        bgcolor: `rgba(${stagesColors[s.value]}, 0.5)`,
                                    },
                                    '&.Mui-selected': {
                                        bgcolor: `rgba(${stagesColors[s.value]}, 0.4) !important`,
                                        '&:hover': {
                                            bgcolor: `rgba(${stagesColors[s.value]}, 0.6) !important`,
                                        },
                                    },
                                }}
                            >
                                <Checkbox size='small' checked={stagesSelected.includes(s.value)} sx={{ color: 'white', '&.Mui-checked': { color: 'orange' } }} />
                                <ListItemText primary={s.label} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Paper>
        </Box>,
        document.getElementById("map-controls-left-top-first-row")
    );
};

export default StageSelectControl;